<template>
    <div class="class-list p-b-64 page">
        <div v-if="indicatorType" style="height: 80vh; display: flex; flex-direction: row; align-items: center">
            <indicatorEmpty :type="indicatorType" :message="indicatorMessage"></indicatorEmpty>
        </div>
        <div v-if="!indicatorType">
            <div style="padding-bottom: 75px">
                <div v-if="approveInfo.titleCustom" style="padding: 10px 0px 10px 0px" class="approve-create">
                    <van-field
                        v-model="title"
                        class="approve-create"
                        placeholder="请输入"
                        label="标题"
                        center
                        maxlength="150"
                        input-align="right"
                        :required="true"
                    ></van-field>
                </div>
                <div v-for="(cmpt, i) in itemsList" :key="i"
                     style="font-size: 15px; text-align: left;margin-bottom: 10px">
                    <createCompnents :cmpt="cmpt"
                                     :key="cmpt.componentName+'-'+i"
                                     :extra="{parentIndex: i}"
                                     v-on:onAutoComplete="onAutoComplete(arguments, itemsList)"/>
                </div>
                <div v-if="optionalNodes.length">
                    <van-cell
                        title="自选的审批节点"
                        :required="false">
                    </van-cell>
                    <div v-for="(optionalNode, i) in optionalNodes" :key="i" style="background-color: white">
                        <div v-if="i > 0" style="height: 1px; background-color: #eee;margin: 0px 15px"></div>
                        <div class="optional">
                            <div class="optional-title">
                                <div class="optional-title-name">{{optionalNode.nodeName}}</div>
                                <div v-if="optionalNode.users.length == 0"
                                     class="optional-title-hint">请选择审批人
                                </div>
                                <div v-else-if="optionalNode.selectMulti == '1'" class="optional-title-hint">已选择</div>
                                <div v-else class="optional-title-hint">
                                    <div v-if="optionalNode.actType == 'or'">
                                        {{optionalNode.users.length}}人或签
                                    </div>
                                    <div v-else-if="optionalNode.actType == 'and'">
                                        {{optionalNode.users.length}}人会签
                                    </div>
                                    <div v-else>
                                        {{optionalNode.users.length}}人依次审批
                                    </div>
                                </div>
                            </div>
                            <div style="flex: 1"></div>
                            <div v-if="optionalNode.users.length <= 2"
                                 style="display: flex; align-items: center; flex-direction: row">
                                <div v-for="(user, j) in optionalNode.users" :key="j"
                                     style="display: flex; align-items: center; flex-direction: row">
                                    <div class="optional-user">
                                        <div class="upload-image-layout"
                                             style="height: 40px; width: 40px;">
                                            <img class="portrait-shape" :src="user.portraitImgUrl"/>
                                            <img @click="optionalNode.users.splice(j, 1)"
                                                 style="position: absolute;top: 0px;right: 4px;width: 16px;height: 16px;overflow: visible"
                                                 src="../../assets/img/icon/删除@3x.png">
                                        </div>
                                        <span
                                            style="font-size: 12px; color: #333; margin-top: 8px">{{user.realName}}</span>
                                    </div>
                                    <img v-if="optionalNode.actType=='sort'" style="width: 10px;"
                                         src="../../assets/img/右@2x.png"/>
                                </div>
                            </div>
                            <div v-else style="display: flex; align-items: center; flex-direction: row">
                                <div class="optional-user">
                                    <div class="upload-image-layout"
                                         style="height: 40px; width: 40px;">
                                        <img @click="optionalDialogShow = true; optionalDialogData = optionalNode"
                                             class="portrait-shape"
                                             src="../../assets/img/icon/duoren.png"/>
                                    </div>
                                    <span
                                        style="font-size: 12px; color: #333; margin-top: 8px">查看全部</span>
                                </div>
                                <img v-if="optionalNode.actType=='sort'" style="width: 10px;"
                                     src="../../assets/img/右@2x.png"/>
                                <div class="optional-user">
                                    <div class="upload-image-layout"
                                         style="height: 40px; width: 40px;">
                                        <img class="portrait-shape"
                                             :src="optionalNode.users[optionalNode.users.length - 1].portraitImgUrl"/>
                                        <img @click="optionalNode.users.splice(optionalNode.users.length - 1, 1)"
                                             style="position: absolute;top: 0px;right: 4px;width: 16px;height: 16px;overflow: visible"
                                             src="../../assets/img/icon/删除@3x.png">
                                    </div>
                                    <span
                                        style="font-size: 12px; color: #333; margin-top: 8px">{{optionalNode.users[optionalNode.users.length - 1].realName}}</span>
                                </div>
                                <img v-if="optionalNode.actType=='sort'" style="width: 10px;"
                                     src="../../assets/img/右@2x.png"/>
                            </div>
                            <div v-if="optionalNode.selectMulti == '0' || optionalNode.users.length == 0"
                                 class="optional-user">
                                <div class="upload-image-layout"
                                     style="height: 40px; width: 40px;">
                                    <img src="../../assets/img/create/上传按钮.png"
                                         @click="pickApproveNode(optionalNode)"/>
                                    <div
                                        style="font-size: 13px; color: #f44;position: absolute;top: 6px;right: 6px;width: 16px;height: 16px;overflow: visible">
                                        *
                                    </div>
                                </div>
                                <span
                                    style="font-size: 12px; color: #fff; margin-top: 8px">1</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 5px"
                     v-if="notifierList && notifierList.length > 0">
                    <van-cell
                        title="抄送人">
                        <template slot>
                            <div class="ellipsis-multi-1" style="color: #a4afbc; font-size: 12px">
                            </div>
                        </template>
                    </van-cell>
                    <van-row
                        style="background-color: white; padding: 5px 15px 10px 15px">
                        <van-col class="upload-image" v-for="(notifier, i) in notifierList" :key=i span="6"
                                 tag="a">
                            <div class="process-item">
                                <div class="process-item-left">
                                    <div class="upload-image-layout"
                                         style="height: 40px; width: 40px;">
                                        <img class="portrait-shape" :src="getNotifierPortrait(notifier)"/>
                                        <img v-if="notifier.canDelete" @click="notifierList.splice(i, 1)"
                                             style="position: absolute;top: -2px;right: -4px;width: 16px;height: 16px;overflow: visible"
                                             src="../../assets/img/icon/删除@3x.png">
                                    </div>
                                    <span
                                        style="font-size: 12px; color: #333; margin-top: 8px">{{getNotifierName(notifier)}}</span>
                                    <span class="process-item-role"
                                          :style="{'visibility': notifier.label ? 'visible':'hidden'}">{{notifier.label}}</span>
                                </div>
                                <div class="process-item-right"></div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div id="cmpt-process" style="margin-top: 10px">
                    <van-cell
                        title="流程图"
                        :required="false">
                    </van-cell>
                    <div class="mountNode" id="mountNode" style="background-color: white;"></div>
                </div>
            </div>

            <div v-if="showSubmit" style="position: fixed; left: 25px; bottom: 15px; right: 25px">
                <van-button type="default" @click="showResult"
                            style="width: 100%; color: #fff; background-color: #08B0FA; height: 45px; border-radius: 3px; border: 0px transparent solid">
                    提交
                </van-button>
            </div>
        </div>

        <van-dialog
            v-model="optionalDialogShow"
        >
            <div style="padding: 15px 15px 15px 15px">
                <span v-if="optionalDialogData.actType=='or'" style="color: #bbb; font-size: 12px">以下成员一人审批即可</span>
                <span v-else-if="optionalDialogData.actType=='and'"
                      style="color: #bbb; font-size: 12px">须以下所有人审批通过</span>
                <span v-else-if="optionalDialogData.actType=='sort'"
                      style="color: #bbb; font-size: 12px">以下人员依次审批</span>
                <div style=" overflow-y: scroll; max-height: 60vh">
                    <div
                        style="display: flex; flex-direction: row; align-items: center;margin: 10px 20px 0px 20px;"
                        v-for="(user, i) in optionalDialogData.users"
                        :key="i">
                        <img class="portrait-shape portrait-size-30"
                             :src="user.portraitImgUrl">
                        <span class="flow-row-user"
                              style="margin-left: 10px; flex: 1; text-align: left">{{user.realName}}</span>
                        <img style="width: 20px" @click="optionalDialogData.users.splice(i, 1)"
                             src="../../assets/img/icon/删除@3x.png">
                    </div>
                </div>
            </div>
        </van-dialog>

        <van-dialog
            v-model="chooseDialogShow"
            show-cancel-button
            :before-close="confirmChoose"
        >
            <div style="padding: 15px 15px 15px 15px">
                <!--<span style="color: #bbb; font-size: 12px">以下人员依次审批</span>-->
                <!--<span v-if="chooseDialogData.actType=='or'" style="color: #bbb; font-size: 12px">以下成员一人审批即可</span>-->
                <!--<span v-else-if="chooseDialogData.actType=='and'"-->
                <!--style="color: #bbb; font-size: 12px">须以下所有人审批通过</span>-->
                <!--<span v-else-if="chooseDialogData.actType=='sort'"-->
                <!--style="color: #bbb; font-size: 12px">以下人员依次审批</span>-->
                <div style="overflow-y: scroll; max-height: 60vh">
                    <div
                        v-for="(user, i) in chooseDialogData.users"
                        :key="i">
                        <div
                            @click="user.isSelected = !user.isSelected"
                            style="display: flex; flex-direction: row; align-items: center;margin: 10px 20px 5px 20px;">
                            <img class="portrait-shape portrait-size-30"
                                 :src="user.portraitImgUrl">
                            <div style="text-align: left; margin-left: 10px; flex: 1; font-size: 14px">
                                <div>
                                    <span>{{user.realName}}</span>

                                    <span v-if="user.departmentPositionCd == '3'"
                                          style="margin-left: 10px; font-size: 12px; color: #a4afbc">主负责人</span>
                                </div>
                                <div style="color: #a4afbc; font-size: 12px; margin-top: 5px">
                                    {{user.fullName}}
                                </div>
                            </div>
                            <van-checkbox v-model="user.isSelected" :change="changeChoose(user)"></van-checkbox>
                        </div>
                    </div>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
    import createCompnents from '../approve/createCompnents';
    import head from '../../mixins/head';
    import indicatorEmpty from '../approve/empty';
    import G6 from '@antv/g6';
    import { registerNode } from '../../mixins/g6';
    import componnetInitValue from '../../mixins/component';
    import componentHybird from '../../mixins/component-hybird';

    export default {
        components: {
            createCompnents,
            indicatorEmpty
        },
        name: 'flow-create',
        mixins: [head, componnetInitValue, componentHybird],
        data() {
            return {
                title: '',
                approveInfo: {},
                userDetails: {}, //用户信息
                repeatType: '', //去重类型
                noticeType: '', //抄送类型
                notifierList: [], //抄送人
                flowData: '',

                baseForm: [],
                detailData: {},

                currentNodeId: '',
                indicatorType: 0,
                indicatorMessage: '',

                showSubmit: false,
                graph: '',
                optionalNodes: [],
                optionalDialogShow: false,
                optionalDialogData: {
                    actType: '',
                    users: []
                },
                chooseDialogShow: false,
                chooseDialogData: {
                    actType: '',
                    multi: false,
                    users: [],
                    selected: []
                }
            };
        },
        props: {},
        watch: {
            '$route': 'inited'
        },
        computed: {},
        created() {
        },
        mounted() {
            window.returnValue = (vals, extra) => {
                if (!this.returnValueApproveCreate(vals, extra)) {
                    this.returnValue(vals, extra);
                }
            };
            this.inited();
            this.init();
        },
        beforeDestroy() {
            this.graph.destroy();
        },
        methods: {

            inited() {
                console.log('=======inited=======');
                if (this.$route.name == 'flow-create') {
                    this.setTitle(this.$route.query.title || '创建审批');
                    window.moreButton({});
                }
            },

            init() {
                console.log('=======init=======');
                if (window.saveInstance[window.getCurrentPath()]) {
                    window.restoreSaveInstance(window.getCurrentPath(), this.$data);
                    if (!_.isEmpty(window.tempRelate) && !_.isEmpty(window.tempRelate.data)) {
                        let tempRelate = _.cloneDeep(window.tempRelate.data);
                        let extra = _.cloneDeep(window.tempRelate.extra);
                        window.tempRelate = {};
                        this.returnValue(JSON.stringify(tempRelate), JSON.stringify(extra));
                    }
                    if (this.flowData) {
                        this.initG6();
                    }
                } else {
                    this.getData();
                }
            },

            /**
             * 获取数据
             */
            getData() {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    id: this.$route.query.id
                };
                this.$http.post('badu/eaa/queryCompanyApproveFormAndProcessSetting.do', param).then((response) => {
                    this.$toast.clear();
                    this.initData(response.data);
                    this.showSubmit = true;
                }).catch((error) => {
                    console.log('getData error', error);
                    this.$toast.clear();
                    this.indicatorType = error.rspCode == -100 && (error.status != 403 || error.status != 500) ? 1 : 3;
                    this.indicatorMessage = error.rspMsg;
                });
            },

            /**
             * 获取数据
             */
            getUsers(ids) {
                console.log('getUsers', ids);

                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });
                let param = {
                    profileIds: ids,
                    stateCds: '1'
                };
                this.$http.post('user/pageCompanyUser.do', param).then((response) => {
                    this.$toast.clear();
                    let tempList = [];
                    if (response.data && response.data.result) {
                        let users = response.data.result;
                        for (let i = 0; i < users.length; i++) {
                            let user = users[i];
                            tempList.push({
                                profileId: user.profileId,
                                realName: user.realName,
                                fullName: user.fullName,
                                departmentPositionCd: user.departmentPositionCd,
                                isSelected: false,
                                portraitImgUrl: user.userportraitImgUrl
                            });
                        }
                        this.chooseDialogData.users.push(...tempList);
                        this.chooseDialogShow = true;
                    }
                }).catch((error) => {
                    console.log('getData error', error);
                    this.$toast.clear();
                    this.$toast.show('获取用户失败');
                });
            },

            /**
             * 初始化数据
             * @param data
             */
            initData(data) {
                window.oldFollow = data;
                this.approveInfo = data;
                this.flowData = JSON.parse(data.process);
                //查找自选节点
                this.optionalNodes.splice(0, this.optionalNodes.length);
                let nodes = this.flowData.nodes;
                if (nodes) {
                    for (let i = 0; i < nodes.length; i++) {
                        let node = nodes[i];
                        if (node.shape === 'NODE_FLOW') {
                            let rules = node.rules;
                            for (let j = 0; j < rules.length; j++) {
                                let rule = rules[j];
                                if (rule.type === 'initiator_choice') {
                                    let temp = _.cloneDeep(rule);
                                    temp.nodeName = node.label;
                                    temp.nodeId = node.id;
                                    temp.users = [];
                                    this.optionalNodes.push(temp);
                                    break;
                                }
                            }
                        }
                    }
                }

                //用户信息
                this.userDetails = this.approveInfo.userDetails;
                //初始化抄送人
                this.notifierList.splice(0, this.notifierList.length);
                if (this.flowData.notifiers && this.flowData.notifiers.length > 0) {
                    for (let i = 0; i < this.flowData.notifiers.length; i++) {
                        let notifier = this.flowData.notifiers[i];
                        if (notifier.type == 'role') {
                            if (data.roleDetails && data.roleDetails[notifier.value]) {

                            } else {
                                continue;
                            }
                        }
                        notifier.canDelete = false;
                        this.notifierList.push(_.cloneDeep(notifier));
                    }
                }
                // 初始化流程图
                this.initG6();

                let currentNode = null;
                let nodeForm = null;
                for (let i = 0; i < this.flowData.nodes.length; i++) {
                    if (this.flowData.nodes[i].shape == 'NODE_CREATE_USER') {
                        currentNode = this.flowData.nodes[i];
                        nodeForm = currentNode.form;
                    }
                }
                if (!nodeForm) {
                    this.$toast.fail({
                        duration: 0,
                        forbidClick: true,
                        message: '流程未设置发起人节点'
                    });
                    return;
                }
                this.currentNodeId = currentNode.id;
                //初始化表单
                let table = JSON.parse(data.table);
                this.baseForm = _.cloneDeep(table);

                if (this.$route.query.isAgain) {
                    this.detailData = _.cloneDeep(window.tempData);
                    if (this.approveInfo.titleCustom) {
                        this.title = _.cloneDeep(window.tempTitle);
                    }
                    window.tempData = null;
                    window.tempTitle = null;
                }
                if (!this.title && this.approveInfo.titleCustom) {
                    this.title = data.approveName;
                }
                console.log('before initData', table);

                let tempFormList = [];
                for (let i = 0; i < table.length; i++) {
                    let cmpt = table[i];
                    if (!nodeForm[cmpt.props.id] || !nodeForm[cmpt.props.id].edit) {
                        continue;
                    }
                    cmpt.props.required = nodeForm[cmpt.props.id].required;
                    tempFormList.push(_.cloneDeep(cmpt));
                }

                this.initRelate(tempFormList, this.detailData);
                this.initFormValue(this.itemsList, tempFormList, this.detailData);

                this.repeatType = data.repeatType;
                this.noticeType = data.noticeType;
            },

            /**
             * 初始化G6流程图
             */
            initG6() {
                console.log('initG6', this.flowData);
                G6.track(false);
                registerNode(G6);
                this.graph = new G6.Graph({
                    container: 'mountNode',
                    // width: 320,
                    height: 320,
                    fitView: 'autoZoom',
                    fitViewPadding: 15,
                    minZoom: 0.2,
                    maxZoom: 1
                });
                this.graph.read(this.flowData);
            },

            /**
             * 点击提交按钮
             **/
            showResult() {
                if (this.approveInfo.titleCustom && !this.title) {
                    this.$toast({
                        type: 'text',
                        forbidClick: true,
                        message: '标题不能为空',
                        duration: 1000
                    });
                    return;
                }
                let emptyResult = this.checkEmpty(this.itemsList);
                if (!emptyResult.success) {
                    this.showEmptyTip(emptyResult.label, emptyResult.extra);
                    return;
                }

                let optionalMap = {};
                if (this.optionalNodes.length) {
                    for (let i = 0; i < this.optionalNodes.length; i++) {
                        let node = this.optionalNodes[i];
                        if (node.users && node.users.length) {
                            let userIds = [];
                            for (let j = 0; j < node.users.length; j++) {
                                userIds.push(node.users[j].profileId);
                            }
                            optionalMap[node.nodeId] = {
                                actType: node.actType,
                                userIds: userIds
                            };
                            console.log('optionalMap', JSON.stringify(optionalMap));
                        } else {
                            this.$toast({
                                type: 'text',
                                forbidClick: true,
                                message: '请选择' + node.nodeName + '节点的审批人',
                                duration: 1000
                            });
                            return;
                        }
                    }
                }

                let content = this.loopCompnents(this.itemsList);
                console.log('showResult-content', content);
                let showContent = this.listDetails(this.baseForm, content);
                console.log('showResult-showContent', showContent);
                let commitData = this.loopCondition(this.approveInfo.condition, content);
                this.submit(showContent, content, commitData.condition, commitData.hrProperty, optionalMap);
            },

            /**
             * 提交数据
             * @param showContent 列表展示内容
             * @param content 表单的值
             * @param condition 条件的值
             * @param hrProperty 人力资源的值
             */
            submit(showContent, content, condition, hrProperty, optionalMap) {
                this.$toast.loading({
                    duration: 0,
                    loadingType: 'spinner',
                    forbidClick: true
                });

                let param = {
                    approveId: this.$route.query.id,
                    approveName: this.approveInfo.approveName,
                    title: this.title || '',
                    showContent: JSON.stringify(showContent),
                    content: JSON.stringify(content),
                    form: this.approveInfo.table,
                    process: this.approveInfo.process,
                    conditions: this.approveInfo.condition,
                    params: JSON.stringify(condition), //审批条件
                    notifiers: JSON.stringify(this.notifierList),
                    hrProperty: JSON.stringify(hrProperty), //角色自选
                    noticeType: this.approveInfo.noticeType,
                    repeatType: this.approveInfo.repeatType,
                    opinionRemind: this.approveInfo.opinionRemind,
                    opinionRequired: this.approveInfo.opinionRequired,
                    opinionHide: this.approveInfo.opinionHide,
                    initiatorChoice: JSON.stringify(optionalMap)
                };
                console.log('submit', param);
                this.$http.post('badu/eaa/addApproveWorkFlow_V2.do', param).then((response) => {
                    if (response.rspCode == 0) {
                        this.$toast.clear();
                        this.$toast.success({
                            forbidClick: true,
                            message: '提交成功'
                        });
                        setTimeout(() => {
                            this.REPLACE({
                                name: 'flow-detail',
                                query: { id: response.data, time: new Date().getTime() }
                            });
                        }, 1000);
                    } else {
                        this.$toast.fail({
                            forbidClick: true,
                            message: '提交失败'
                        });
                    }
                }).catch((error) => {
                    console.log(error);
                    this.$toast.clear();
                    if (error.rspCode == 24) {
                        this.$toast.fail({
                            forbidClick: true,
                            message: '审批人已失效，请联系管理员'
                        });
                    } else {
                        this.$toast.fail({
                            forbidClick: true,
                            message: error.rspMsg || '网络异常'
                        });
                    }
                });
            },

            /**
             * 获取人员头像
             * @param notifier
             * @returns {*}
             */
            getNotifierPortrait(notifier) {
                if (notifier.type == 'user') {
                    return this.userDetails[notifier.value].portraitImgUrl;
                }
                return require('../../assets/img/icon/duoren.png');
            },

            /**
             * 获取抄送人名称
             * @param notifier
             * @returns {*}
             */
            getNotifierName(notifier) {
                if (notifier.type == 'user') {
                    return this.userDetails[notifier.value].realName;
                } else if (notifier.type == 'role') {
                    return '角色';
                } else if (notifier.type == 'management') {
                    return '主管';
                }
                return '';
            },

            /**
             * js调原生后返回数据
             * @param val
             * @param extra js调原生时传过去的值
             */
            returnValueApproveCreate(val, extra) {
                console.log('returnValue', val, extra);
                let extraData = JSON.parse(extra);
                if (extraData.returnType == 'pickUser') {
                    if (extraData.nodeId) {
                        let user = JSON.parse(val);
                        for (let i = 0; i < this.optionalNodes.length; i++) {
                            let optionalNode = this.optionalNodes[i];
                            if (optionalNode.nodeId == extraData.nodeId) {
                                optionalNode.users.push(...user);
                                break;
                            }
                        }
                        return true;
                    }
                } else if (extraData.returnType == 'pickRole') {
                    if (extraData.nodeId) {
                        let user = JSON.parse(val);
                        for (let i = 0; i < this.optionalNodes.length; i++) {
                            let optionalNode = this.optionalNodes[i];
                            if (optionalNode.nodeId == extraData.nodeId) {
                                optionalNode.users.push(...user);
                                break;
                            }
                        }
                        return true;
                    }
                }
                return false;
            },

            pickApproveNode(node) {
                let selectMulti = node.selectMulti == '0';
                let selected = [];
                // for (let i = 0; i < node.users.length; i++) {
                //     selected.push(node.users[i].profileId);
                // }
                let extra = {
                    nodeId: node.nodeId
                };
                if (node.selectType == 'allUser') {
                    window.pickUser(selectMulti, selected, 0, false, extra);
                } else if (node.selectType == 'role') {
                    window.pickRole(node.labels[0], selectMulti, selected, extra);
                } else if (node.selectType == 'user') {
                    this.chooseDialogData.nodeId = node.nodeId;
                    this.chooseDialogData.actType = node.actType;
                    this.chooseDialogData.multi = node.selectMulti == '0';
                    this.chooseDialogData.users.splice(0, this.chooseDialogData.users.length);
                    this.chooseDialogData.selected.splice(0, this.chooseDialogData.selected.length);
                    this.getUsers(node.approvals.join(','));
                }
            },

            changeChoose(item) {
                let existIndex = -1;
                for (let i = 0; i < this.chooseDialogData.selected.length; i++) {
                    if (item.profileId == this.chooseDialogData.selected[i]) {
                        existIndex = i;
                        break;
                    }
                }
                console.log('changeChoose', existIndex, item);
                if (existIndex >= 0 && !item.isSelected) {
                    this.chooseDialogData.selected.splice(existIndex, 1);
                } else if (existIndex == -1 && item.isSelected) {
                    if (!this.chooseDialogData.multi) {
                        this.chooseDialogData.selected.splice(0, this.chooseDialogData.selected.length);
                        for (let i = 0; i < this.chooseDialogData.users.length; i++) {
                            let user = this.chooseDialogData.users[i];
                            if (user.profileId != item.profileId && user.isSelected) {
                                user.isSelected = false;
                            }
                        }
                    }
                    this.chooseDialogData.selected.push(item.profileId);
                }
            },

            confirmChoose(action, done) {
                console.log('confirmChoose', action, done);
                if (action == 'confirm') {
                    let nodeId = this.chooseDialogData.nodeId;
                    let node;
                    for (let i = 0; i < this.optionalNodes.length; i++) {
                        if (this.optionalNodes[i].nodeId == nodeId) {
                            node = this.optionalNodes[i];
                            break;
                        }
                    }
                    if (node) {
                        let temp = [];
                        for (let i = 0; i < this.chooseDialogData.selected.length; i++) {
                            for (let j = 0; j < this.chooseDialogData.users.length; j++) {
                                let user = this.chooseDialogData.users[j];
                                if (user.profileId == this.chooseDialogData.selected[i]) {
                                    temp.push(user);
                                    break;
                                }
                            }
                        }
                        node.users.push(...temp);
                    }
                }
                done();
            },

            onAutoComplete(arg, cmptList) {
                console.log('onAutoComplete', arg, cmptList);
                let result = arg[0];
                let modelId = arg[1];
                cmptList.forEach(function (cmpt) {
                    if (cmpt.autoWrite && cmpt.autoWrite.modelId == modelId) {
                        cmpt.value = result[cmpt.autoWrite.key] || '';
                    }
                });
            }
        }
    };
</script>
<style lang="scss">
    @import '../../assets/scss/approve-create-field.scss';
</style>

<style lang="scss" scoped
>
    @import '../../assets/scss/approve.scss';
    @import '../../assets/scss/approve-create.scss';

    .optional {
        display: flex;
        flex-direction: row;
        align-items: center;
        padding: 10px 15px;

        .optional-title {
            text-align: left;
            max-width: 30%;

            .optional-title-name {
                font-size: 15px;
                color: #333;
            }

            .optional-title-hint {
                font-size: 13px;
                color: #777;
                margin-top: 8px
            }
        }

        .optional-user {
            display: flex;
            flex-direction: column;
            width: 60px;
            align-items: center;
            position: relative;
        }

    }

</style>
